export const REPORTPERMITS_SEARCH = 'REPORTPERMITS_SEARCH';
export const REPORTPERMITS_PAGE = 'REPORTPERMITS_PAGE';
export const REPORTPERMITS_STARTDATE = 'REPORTPERMITS_STARTDATE';
export const REPORTPERMITS_ENDDATE = 'REPORTPERMITS_ENDDATE';
export const REPORTPERMITS_MANAGER = 'REPORTPERMITS_MANAGER';
export const REPORTPERMITS_THREEPSUPPLIER = 'REPORTPERMITS_THREEPSUPPLIER';
